import React, {useState,useEffect,useRef,useLayoutEffect} from 'react';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import Select from 'react-select'


const DateFilter = (prop) => {

    const ref = useRef()

    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [selectedDate, setSelectedDate] = useState("")
    const [selectedDateLabel, setSelectedDateLabel] = useState("")
    const [dateFrom, setDateFrom] = useQueryParam('date_from', StringParam);
    const [dateTo, setDateTo] = useQueryParam('date_to', StringParam);
    const [closeFilter, setCloseFilter] = useState(false);

    const selectOptions=[
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'last7days', label: 'Last 7 days' },
        { value: 'last30days', label: 'Last 30 days' },

    ];

    const closeFilterFunc=()=>{
        setDateFrom(undefined);
        setDateTo(undefined);
        prop.closeFilter(prop.filterDetail['name']);
        prop.filtering();
    }
    const completeSelect=()=>{

        if(selectedDate=="today"){
            var dateRange = getDateRange(0);
            setDateFrom(dateRange.date_from);
            setDateTo(dateRange.date_to);
            prop.filtering();

        }
        if(selectedDate=="yesterday"){
            var dateRange = getDateRange(1);
            setDateFrom(dateRange.date_from);
            setDateTo(dateRange.date_to);
            prop.filtering();
        }
        if(selectedDate=="last7days"){

            var dateRange = getDateRange(6);

            setDateFrom(dateRange.date_from);
            setDateTo(dateRange.date_to);
            prop.filtering();
        }
        if(selectedDate=="last30days"){
            var dateRange = getDateRange(29);
            setDateFrom(dateRange.date_from);
            setDateTo(dateRange.date_to);
            prop.filtering();
        }
    }

    const onMouseOver=()=>{
        setCloseFilter(true);
    }
    const onMouseOut=()=>{
        setCloseFilter(false);
    }
    const getDateRange=(day)=>{
        var date=new Date();
        var last = new Date(date.getTime() - (day * 24 * 60 * 60 * 1000));
        var dateMonth=(date.getMonth()+1);
        if(dateMonth<9){
            dateMonth="0"+dateMonth;
        }
        var lastMonth=(last.getMonth()+1);
        if(lastMonth<9){
            lastMonth="0"+lastMonth;
        }

        var dateDay=date.getDate();
        if(dateDay<9){
            dateDay="0"+dateDay;
        }

        var lastDay=last.getDate();
        if(lastDay<9){
            lastDay="0"+lastDay;
        }

        var date_to=date.getFullYear()+"-"+dateMonth+"-"+dateDay;
        var date_from=last.getFullYear()+"-"+lastMonth+"-"+lastDay;
        if(day==1){
            date_to=date_from;
        }
        return {
            "date_from":date_from,
            "date_to":date_to
        };

    }

    const closeWrap=()=>{

        if(typeof dateFrom==="undefined" || typeof dateTo==="undefined"){
            setDateFrom(undefined);
            setDateTo(undefined);
            prop.closeFilter(prop.filterDetail['name']);
        }
        setIsMenuOpen(false);
    }
    const doneSelect=()=>{
        completeSelect();
        setIsMenuOpen(false);
    }
    const selectDateRange=(selectedOption)=>{


        setSelectedDate(selectedOption.value);
        setSelectedDateLabel(selectedOption.label);

    }
    const  changeMenuOpen=(state)=>{
        prop.changeShowIs(state,prop.filterDetail['name']);
    }
    useEffect(() => {
        if(typeof dateFrom!=="undefined" && typeof dateTo!=="undefined"){
            var d1=new Date(dateFrom);
            var d2=new Date(dateTo);
            var ddiff=((d1.getTime()-d2.getTime())/(1000 * 3600 * 24)*-1)+1;
            if(ddiff==7){
                setSelectedDate("last7days");
                setSelectedDateLabel("Last 7 Days");
            }
            if(ddiff==30){
                setSelectedDate("last30days");
                setSelectedDateLabel("Last 30 Days");
            }
            if(ddiff==1){
                var dateRange = getDateRange(0);

                if(dateRange.date_from==dateFrom){
                    setSelectedDate("today");
                    setSelectedDateLabel("Today");
                }
                 dateRange = getDateRange(1);
                    if(dateRange.date_from==dateFrom){
                        setSelectedDate("yesterday");
                        setSelectedDateLabel("Yesterday");
                    }

            }

        }
        if(!prop.showis){

            setIsMenuOpen(true);
            changeMenuOpen(true);
        }
    }, [prop.showis])

    useEffect(() => {

        const checkIfClickedOutside = e => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                setIsMenuOpen(false);
                if(typeof dateFrom==="undefined" || typeof dateTo==="undefined"){
                    setDateFrom(undefined);
                    setDateTo(undefined);
                    prop.closeFilter(prop.filterDetail['name']);
                }

            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [isMenuOpen])

        return (

           <div
               className="filter-item"
               ref={ref}>
               <button
                   onMouseEnter={onMouseOver}
                   onMouseLeave={onMouseOut}
                   onClick={() => setIsMenuOpen(oldState => !oldState)}
                   className=" selected-filter-button">
                   {closeFilter === false &&
                   <i className={prop.filterDetail['icon']} ></i>
                   }

                   {closeFilter===true &&
                   <i
                       onClick={closeFilterFunc}
                       className="bx bx-x" ></i>
                   }

                   {selectedDateLabel != "" &&
                   <span>{selectedDateLabel}</span>
                   }
                   {selectedDateLabel == "" &&
                   <span>{prop.filterDetail['name']}</span>
                   }

               </button>

               {isMenuOpen === true &&
               <div className="filter-item-wrap">
                   <div className="filter-item-content">
                       <div className="filter-item-content-header">
                           <span><i className={prop.filterDetail['icon']}></i></span>
                           <span>{prop.filterDetail['name']}</span>

                       </div>
                       <div className="form">
                           <Select
                               defaultValue={
                                   selectOptions.filter(option =>
                                       option.value == selectedDate)
                               }
                               options={selectOptions}
                               closeMenuOnSelect={true}
                               placeholder="choose date range"
                               onChange={selectDateRange}
                               noOptionsMessage={() => "item not found"}

                           />
                       </div>
                       <div className="form">
                           {selectedDate == "" &&
                           <button
                               onClick={closeWrap}
                               className="btn btn-primary btn-lg btn-block">Close</button>
                           }
                           {selectedDate != "" &&
                           <button
                               onClick={doneSelect}
                               className="btn btn-primary btn-lg btn-block"
                           >Done</button>
                           }
                       </div>
                   </div>
               </div>
               }
           </div>

        );

};

export default DateFilter;
